import { Box, MenuItem, Paper, Select } from '@mui/material';

import SeasonalChartIcon from '@/assets/icons/SeasonalChart';
import SimpleChartIcon from '@/assets/icons/SimpleChart';
import Typography from '@/components/Typography';
import { DEFAULT_SEASONAL_YEARS } from '@/features/Dashboard/form/AppForm/components/SelectSeasonalRange';
import { useAppForm } from '@/features/Dashboard/form/AppForm/context';
import { AppType } from '@/features/Dashboard/types';

const ChartTypeLabel = ({
  icon,
  type,
  info
}: {
  icon: React.ReactNode;
  type: string;
  info: string;
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
      {icon}
      <Typography size={14}>{type}</Typography>
      <Typography
        size={12}
        sx={{ fontWeight: 500, color: 'info.dark' }}
      >
        {info}
      </Typography>
    </Box>
  );
};

const items = [
  {
    value: AppType.Spot,
    label: (
      <ChartTypeLabel
        icon={<SimpleChartIcon />}
        info='Up to 6 items'
        type='Spot History chart'
      />
    )
  },
  {
    value: AppType.Seasonal,
    label: (
      <ChartTypeLabel
        icon={<SeasonalChartIcon />}
        info='1 item only'
        type='Seasonal chart'
      />
    )
  }
];

export const SelectChartType = () => {
  const { form } = useAppForm();
  return (
    <form.Field
      children={field => (
        <Box
          component={Paper}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            p: 2,
            width: '100%',
            gap: 1
          }}
        >
          <Typography
            size={14}
            sx={{ fontWeight: 700 }}
          >
            Chart type
          </Typography>
          <Typography
            size={12}
            sx={{ fontWeight: 500, color: 'info.dark', mb: 1 }}
          >
            Select the type of chart you want to create
          </Typography>
          <Select
            sx={{
              '& fieldset': { borderColor: '#fff !important' },
              '&:hover fieldset': { borderColor: '#fff !important' },
              '&.Mui-focused fieldset': { borderColor: '#fff !important' }
            }}
            value={field.state.value}
            onChange={e => {
              const nextType = e.target.value as AppType;
              field.handleChange(nextType as any);
              const values = form.state.values;
              const hasName = !!values && 'name' in values;
              const currentName = hasName ? values.name : undefined;
              if (nextType === AppType.Seasonal) {
                if (!form.getFieldValue('from')) {
                  form.setFieldValue('from', DEFAULT_SEASONAL_YEARS);
                }
                if (hasName && currentName === 'Spot History chart') {
                  form.setFieldValue('name', 'Seasonal chart');
                }
              } else if (nextType === AppType.Spot && hasName && currentName === 'Seasonal chart') {
                form.setFieldValue('name', 'Spot History chart');
              }
            }}
          >
            {items.map(item => (
              <MenuItem
                key={item.value}
                value={item.value}
              >
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}
      name='type'
    />
  );
};
